/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Status = {
    UploadPending: 'UPLOAD_PENDING',
    UploadCompleted: 'UPLOAD_COMPLETED',
    UploadCompletedMissing: 'UPLOAD_COMPLETED_MISSING',
    UploadFailed: 'UPLOAD_FAILED',
    Unknown: 'UNKNOWN'
} as const;
export type Status = typeof Status[keyof typeof Status];


export function instanceOfStatus(value: any): boolean {
    for (const key in Status) {
        if (Object.prototype.hasOwnProperty.call(Status, key)) {
            if (Status[key as keyof typeof Status] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StatusFromJSON(json: any): Status {
    return StatusFromJSONTyped(json, false);
}

export function StatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): Status {
    return json as Status;
}

export function StatusToJSON(value?: Status | null): any {
    return value as any;
}

export function StatusToJSONTyped(value: any, ignoreDiscriminator: boolean): Status {
    return value as Status;
}

